import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"
import { logout } from "@/app/actions"

type User = {
  id: string
  username: string
  name?: string
  email?: string
  avatar?: string
  isAdmin?: boolean
  accessToken: string
  roleId: string
}

type AuthState = {
  user: User | null
  isAuthenticated: boolean
  isAdmin: boolean
  login: (user: User) => void
  logout: () => Promise<void>
  setIsAdmin: (isAdmin: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>()(
  devtools(persist(
    set => ({
      user: null,
      isAuthenticated: false,
      isAdmin: false,
      login: user => set({
        user,
        isAuthenticated: true,
        isAdmin: user.isAdmin ?? false,
      }),
      logout: async () => {
        await logout()
        set({ user: null, isAuthenticated: false, isAdmin: false })
      },
      setIsAdmin: isAdmin => set({ isAdmin }),
      clear: () => set({ user: null, isAuthenticated: false, isAdmin: false }),
    }),
    {
      name: "auth-storage",
      // Only persist these fields
      partialize: state => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        isAdmin: state.isAdmin,
      }),
    },
  )),
)
